export default __webpack_public_path__ + "static/media/ODEImg5.03305818.PNG";